module.exports = __webpack_public_path__ + "static/media/Andrew Jackson (I) - 1832.850f4c83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Andrew Jackson (I) - 1832.jpg
// module id = 437
// module chunks = 0